module.exports = __webpack_public_path__ + "img/番外_学电视剧_05_霸总.d9abbe52.png";